import { isInvoiceEditable, isInvoiceLocked } from "./invoice-lifecycle.ts"
import { type ProjectInvoice } from "../../Project/types/project-invoices.types.tsx"

const INVOICE_ORIGIN_GENERATED = 1
const INVOICE_STATUS_DRAFT = 4

interface Args {
  record: ProjectInvoice
  currentUserId: string
  editInvoice?: boolean
  editForeignInvoice?: boolean
  deleteInvoice?: boolean
  deleteForeignInvoice?: boolean
}

export function getInvoicePermissions({
  record,
  currentUserId,
  deleteInvoice,
  deleteForeignInvoice,
  editInvoice,
  editForeignInvoice
}: Args) {
  const isOwner = record?.created_by === currentUserId
  const isLocked = isInvoiceLocked(record)
  const isIssuedGenerated =
    record?.origin === INVOICE_ORIGIN_GENERATED &&
    record?.status !== INVOICE_STATUS_DRAFT
  const hasDocument =
    (record?.origin === INVOICE_ORIGIN_GENERATED &&
      Boolean(record?.invoice_number)) ||
    (record?.attachments?.length ?? 0) > 0

  const hasEditRights = Boolean(editForeignInvoice || (editInvoice && isOwner))

  return {
    isLocked,
    // Permission-only flag for the shared lifecycle menu, which gates per status itself.
    hasEditRights,
    // External invoices stay correctable until voided; generated ones only as drafts.
    isEditable: isInvoiceEditable(record),
    canEdit: isInvoiceEditable(record) && hasEditRights,
    canDelete:
      !isLocked && (deleteForeignInvoice || (deleteInvoice && isOwner)),
    canDownloadPdf: Boolean(isIssuedGenerated && record?.invoice_number),
    // Broader than canDownloadPdf: an external invoice is previewable from its attachment.
    canPreview: Boolean(record?.status !== INVOICE_STATUS_DRAFT && hasDocument)
  }
}
